const _500_dp = () => ({
	structure: {
		type: 'Page',
		styleId: 'style-k5cfurs9',
		id: '_500_dp',
		components: [
			{
				type: 'Container',
				styleId: 'style-kbgaghvs',
				id: 'comp-kirk42at',
				components: [
					{
						type: 'Component',
						styleId: 'style-khynhdke',
						id: 'comp-khynhdia',
						dataQuery: '#dataItem-khynhdk3',
						skin: 'wixui.skins.ImageX',
						layout: {
							width: 160,
							height: 90,
							x: 0,
							y: 0,
							scale: 1,
							rotationInDegrees: 0,
							fixedPosition: false,
						},
						layoutQuery: '#layout-khynhdkb',
						componentType: 'wixui.ImageX',
					},
					{
						type: 'Container',
						styleId: 'style-khynvdcr',
						id: 'comp-kirk42au',
						components: [
							{
								type: 'Component',
								styleId: 'style-khynr892',
								id: 'comp-kirk42av',
								dataQuery: '#dataItem-khynr88o',
								skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
								layout: {
									width: 160,
									height: 90,
									x: -194,
									y: -44,
									scale: 1,
									rotationInDegrees: 0,
									fixedPosition: false,
								},
								propertyQuery: 'propItem-khynr88v',
								layoutQuery: '#layout-khynr890',
								componentType: 'wysiwyg.viewer.components.WRichText',
							},
							{
								type: 'Component',
								styleId: 'style-khynrb4j',
								id: 'comp-kirk42aw',
								dataQuery: '#dataItem-khynrb4h',
								skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
								layout: {
									width: 160,
									height: 90,
									x: -194,
									y: -44,
									scale: 1,
									rotationInDegrees: 0,
									fixedPosition: false,
								},
								propertyQuery: 'propItem-khynrb4h1',
								layoutQuery: '#layout-khynrb4i',
								componentType: 'wysiwyg.viewer.components.WRichText',
							},
							{
								type: 'Component',
								styleId: 'style-khyp5z7j',
								id: 'comp-kirk42ax',
								dataQuery: '#dataItem-khyp5z79',
								skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
								layout: {
									width: 160,
									height: 90,
									x: -194,
									y: -44,
									scale: 1,
									rotationInDegrees: 0,
									fixedPosition: false,
								},
								propertyQuery: 'propItem-khyp5z7b',
								layoutQuery: '#layout-khyp5z7d',
								componentType: 'wysiwyg.viewer.components.WRichText',
							},
						],
						skin: 'wysiwyg.viewer.skins.area.DefaultAreaSkin',
						layout: {
							width: 558,
							height: 240,
							x: 194,
							y: 44,
							scale: 1,
							rotationInDegrees: 0,
							fixedPosition: false,
						},
						layoutQuery: '#layout-khynvdc6',
						componentType: 'mobile.core.components.Container',
					},
				],
				layout: { width: 100, height: 100, x: 0, y: 0, scale: 1, rotationInDegrees: 0, fixedPosition: false },
				connectionQuery: 'connection-kbuqae8z',
				layoutQuery: '#layout-kbgaghvg',
				componentType: 'responsive.components.Section',
			},
		],
		dataQuery: '#_500_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: { width: 1920, height: 500, x: 0, y: 0, scale: 1, rotationInDegrees: 0, fixedPosition: false },
		mobileHintsQuery: 'mobileHints-j8u779np',
		behaviorQuery: 'behavior-jg9pfpzt',
		connectionQuery: 'connection-kbuqae93',
		layoutQuery: '#layout-k3sr3k5v',
		componentType: 'mobile.core.components.Page',
		breakpointVariantsQuery: 'breakpoints-k3sr3k4j',
	},
	data: {
		component_properties: {
			'propItem-khynr88v': {
				type: 'WRichTextProperties',
				metaData: { schemaVersion: '1.0', autoGenerated: false },
				id: 'propItem-khynr88v',
				brightness: 1,
				packed: true,
				verticalText: false,
			},
			'propItem-khynrb4h1': {
				type: 'WRichTextProperties',
				metaData: { schemaVersion: '1.0', autoGenerated: false },
				id: 'propItem-khynrb4h1',
				brightness: 1,
				packed: true,
				verticalText: false,
			},
			'propItem-khyp5z7b': {
				type: 'WRichTextProperties',
				metaData: { schemaVersion: '1.0', autoGenerated: false },
				id: 'propItem-khyp5z7b',
				brightness: 1,
				packed: true,
				verticalText: false,
			},
		},
		document_data: {
			_500_dp: {
				type: 'Page',
				id: '_500_dp',
				metaData: {
					isPreset: true,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: 'Home',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: 'home',
				hidePage: false,
				isMobileLandingPage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: false,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#_500_dp_k2ltejvo_bg',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
						mediaSizing: 'viewport',
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
				ogImage: '',
			},
			_500_dp_k2ltejvo_bg: {
				type: 'BackgroundMedia',
				id: '_500_dp_k2ltejvo_bg',
				metaData: { isPreset: true, schemaVersion: '2.0', isHidden: false },
				color: '{color_11}',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: { isPreset: true, schemaVersion: '2.0', isHidden: false },
				color: '{color_11}',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
				colorOverlay: '',
				colorOverlayOpacity: 0,
			},
			'dataItem-khynhdk3': {
				type: 'ImageX',
				id: 'dataItem-khynhdk3',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				image: { uri: '0d6674_95c96d34f16749b48e4a2059c7482799~mv2.png', width: 1920, height: 1120, alt: '' },
				scopedData: [],
			},
			'dataItem-khynr88o': {
				type: 'StyledText',
				id: 'dataItem-khynr88o',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				text: '<h1 class="font_2"><span>Just a minute, we&rsquo;re fixing something&nbsp;here.</span></h1>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
				usedFonts: [],
			},
			'dataItem-khynrb4h': {
				type: 'StyledText',
				id: 'dataItem-khynrb4h',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				text: '<p class="font_8"><span>(Error 500)</span></p>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
				usedFonts: [],
			},
			'dataItem-khyp5z79': {
				type: 'StyledText',
				id: 'dataItem-khyp5z79',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				text: '<p class="font_8"><span>We hope to be back online very soon.</span></p>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
				usedFonts: [],
			},
		},
		design_data: {},
		behaviors_data: {
			'behavior-jg9pfpzt': {
				type: 'ObsoleteBehaviorsList',
				id: 'behavior-jg9pfpzt',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				items: '[]',
			},
		},
		connections_data: {
			'connection-kbuqae8z': {
				type: 'ConnectionList',
				id: 'connection-kbuqae8z',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				items: [{ type: 'WixCodeConnectionItem', role: 'section1' }],
			},
			'connection-kbuqae93': {
				type: 'ConnectionList',
				id: 'connection-kbuqae93',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				items: [{ type: 'WixCodeConnectionItem', role: 'page1' }],
			},
		},
		theme_data: {
			'style-k5cftok91': {
				type: 'ComponentStyle',
				id: 'style-k5cftok91',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: { 'alpha-bg': '1', bg: '#010606' },
					propertiesSource: { 'alpha-bg': 'value', bg: 'value' },
					groups: {},
				},
				componentClassName: '',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.page.ResponsivePageWithColorBG',
			},
			'style-k5cfurs9': {
				type: 'RefArray',
				id: 'style-k5cfurs9',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-k5cftok91'],
			},
			'style-kbgaghvq': {
				type: 'ComponentStyle',
				id: 'style-kbgaghvq',
				metaData: { isPreset: true, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: { 'alpha-bg': '0', bg: 'color_11' },
					propertiesSource: { 'alpha-bg': 'value', bg: 'theme' },
					groups: {},
				},
				componentClassName: 'responsive.components.Section',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.area.RectangleArea',
			},
			'style-kbgaghvs': {
				type: 'RefArray',
				id: 'style-kbgaghvs',
				metaData: { isPreset: true, schemaVersion: '1.0', isHidden: false },
				values: ['#style-kbgaghvq'],
			},
			'style-khynhdkc': {
				type: 'ComponentStyle',
				id: 'style-khynhdkc',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						backgroundColor: '#000000',
						boxShadow: '3.54px 3.54px 10px 0px rgba(0,0,0,0.33)',
						borderWidth: '0',
						'alpha-backgroundColor': '0',
						cornerRadius: '0',
						'boxShadowToggleOn-boxShadow': 'false',
						borderColor: '#ffffff',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wixui.ImageX',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wixui.skins.ImageX',
			},
			'style-khynhdke': {
				type: 'RefArray',
				id: 'style-khynhdke',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-khynhdkc'],
			},
			'style-khynr891': {
				type: 'ComponentStyle',
				id: 'style-khynr891',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						textAlign: 'left',
						fontFamily:
							'wfont_0d6674_6d1a3599ace24b5bb110910c1faf1ad0,wf_6d1a3599ace24b5bb110910c1,orig_wix_madefor_display_bold',
						letterSpacing: '0em',
						lineHeight: '1.3em',
						fontSize: '56px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khynr892': {
				type: 'RefArray',
				id: 'style-khynr892',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-khynr891', '#style-khz06o4w', '#style-khyo0wwr'],
			},
			'style-khynrb4i3': {
				type: 'ComponentStyle',
				id: 'style-khynrb4i3',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: '#818586',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '24px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khynrb4j': {
				type: 'RefArray',
				id: 'style-khynrb4j',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-khynrb4i3', '#style-khyp775u', '#style-khyo13yt'],
			},
			'style-khynvdcq': {
				type: 'ComponentStyle',
				id: 'style-khynvdcq',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-brd': '0',
						bg: '#FFFFFF',
						'boxShadowToggleOn-shd': 'false',
						brw: '0px',
						rd: '0px',
						shd: '0px 0px 0px 0px rgba(0,0,0,0.6)',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brd': 'value',
						bg: 'value',
						'boxShadowToggleOn-shd': 'value',
						brw: 'value',
						rd: 'value',
						shd: 'value',
					},
					groups: {},
				},
				componentClassName: 'mobile.core.components.Container',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.area.DefaultAreaSkin',
			},
			'style-khynvdcr': {
				type: 'RefArray',
				id: 'style-khynvdcr',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-khynvdcq'],
			},
			'style-khyo0wwr': {
				type: 'VariantRelation',
				id: 'style-khyo0wwr',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khyo0wwr1',
				from: '#comp-kirk42av',
				variants: ['#breakpoints-kc1s7zda'],
			},
			'style-khyo0wwr1': {
				type: 'ComponentStyle',
				id: 'style-khyo0wwr1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						textAlign: 'left',
						fontFamily:
							'wfont_0d6674_6d1a3599ace24b5bb110910c1faf1ad0,wf_6d1a3599ace24b5bb110910c1,orig_wix_madefor_display_bold',
						letterSpacing: '0em',
						lineHeight: '1.3em',
						fontSize: '32px',
						fontWeight: 'normal',
						textScale__minFontSize: '24',
						textScale__maxFontSize: '32',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khyo13yt': {
				type: 'VariantRelation',
				id: 'style-khyo13yt',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khyo13yt1',
				from: '#comp-kirk42aw',
				variants: ['#breakpoints-kc1s7zda'],
			},
			'style-khyo13yt1': {
				type: 'ComponentStyle',
				id: 'style-khyo13yt1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: '#818586',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '16px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khyp5z7h': {
				type: 'ComponentStyle',
				id: 'style-khyp5z7h',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '24px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khyp5z7i': {
				type: 'ComponentStyle',
				id: 'style-khyp5z7i',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '16px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khyp5z7i1': {
				type: 'VariantRelation',
				id: 'style-khyp5z7i1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khyp5z7i',
				from: '#comp-kirk42ax',
				variants: ['#breakpoints-kc1s7zda'],
			},
			'style-khyp5z7j': {
				type: 'RefArray',
				id: 'style-khyp5z7j',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#style-khyp5z7h', '#style-khyp7ahm', '#style-khyp5z7i1'],
			},
			'style-khyp775u': {
				type: 'VariantRelation',
				id: 'style-khyp775u',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khyp775u1',
				from: '#comp-kirk42aw',
				variants: ['#breakpoints-kc1s7zda1'],
			},
			'style-khyp775u1': {
				type: 'ComponentStyle',
				id: 'style-khyp775u1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: '#818586',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '20px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khyp7ahm': {
				type: 'VariantRelation',
				id: 'style-khyp7ahm',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khyp7ahm1',
				from: '#comp-kirk42ax',
				variants: ['#breakpoints-kc1s7zda1'],
			},
			'style-khyp7ahm1': {
				type: 'ComponentStyle',
				id: 'style-khyp7ahm1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						fontFamily:
							'wfont_0d6674_0aec49dba9b741e38edac1008447e79d,wf_0aec49dba9b741e38edac1008,orig_wix_madefor_display_regular',
						letterSpacing: '0em',
						lineHeight: '1.6em',
						fontSize: '20px',
						fontWeight: 'normal',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
			'style-khz06o4w': {
				type: 'VariantRelation',
				id: 'style-khz06o4w',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#style-khz06o4w1',
				from: '#comp-kirk42av',
				variants: ['#breakpoints-kc1s7zda1'],
			},
			'style-khz06o4w1': {
				type: 'ComponentStyle',
				id: 'style-khz06o4w1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				style: {
					properties: {
						fontStyle: 'normal',
						color: 'color_11',
						textAlign: 'left',
						fontFamily:
							'wfont_0d6674_6d1a3599ace24b5bb110910c1faf1ad0,wf_6d1a3599ace24b5bb110910c1,orig_wix_madefor_display_bold',
						letterSpacing: '0em',
						lineHeight: '1.3em',
						fontSize: '56px',
						fontWeight: 'normal',
						textScale__minFontSize: '20',
						textScale__maxFontSize: '56',
					},
					propertiesSource: {},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.WRichText',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
			},
		},
		mobile_hints: {
			'mobileHints-j8u779np': {
				type: 'MobileHints',
				id: 'mobileHints-j8u779np',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				hidden: false,
			},
		},
		layout_data: {
			'layout-k3sr3k5v': {
				type: 'RefArray',
				id: 'layout-k3sr3k5v',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khynvdaz'],
			},
			'layout-kbgaghvg': {
				type: 'RefArray',
				id: 'layout-kbgaghvg',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khynvday'],
			},
			'layout-khynhdkb': {
				type: 'RefArray',
				id: 'layout-khynhdkb',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khynhemx'],
			},
			'layout-khynhemx': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'auto' },
					minWidth: { type: 'px', value: 0 },
					minHeight: { type: 'px', value: 0 },
					hidden: false,
				},
				itemLayout: {
					type: 'GridItemLayout',
					margins: {
						left: { type: 'px', value: 0 },
						right: { type: 'px', value: 0 },
						top: { type: 'px', value: 0 },
						bottom: { type: 'px', value: 0 },
					},
					gridArea: { rowStart: 1, columnStart: 1, rowEnd: 2, columnEnd: 2 },
					alignSelf: 'stretch',
					justifySelf: 'stretch',
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khynhemx',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khynr890': {
				type: 'RefArray',
				id: 'layout-khynr890',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khynvdhh'],
			},
			'layout-khynrb4i': {
				type: 'RefArray',
				id: 'layout-khynrb4i',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khynvtab'],
			},
			'layout-khynvday': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'vh', value: 100 },
					minHeight: { type: 'px', value: 0 },
				},
				itemLayout: {
					type: 'GridItemLayout',
					gridArea: { rowStart: 1, columnStart: 1, rowEnd: 2, columnEnd: 2 },
					alignSelf: 'stretch',
					justifySelf: 'stretch',
				},
				containerLayout: {
					type: 'GridContainerLayout',
					rows: [{ type: 'fr', value: 1 }],
					columns: [{ type: 'fr', value: 1 }],
				},
				type: 'SingleLayoutData',
				id: 'layout-khynvday',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khynvdaz': {
				componentLayout: { type: 'ComponentLayout', height: { type: 'auto' } },
				itemLayout: {},
				containerLayout: {
					type: 'GridContainerLayout',
					rows: [{ type: 'auto' }],
					columns: [{ type: 'MinMaxSize', min: { type: 'px', value: 0 }, max: { type: 'fr', value: 1 } }],
				},
				type: 'SingleLayoutData',
				id: 'layout-khynvdaz',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khynvdc6': {
				type: 'RefArray',
				id: 'layout-khynvdc6',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khz061dv', '#layout-khz061dw', '#layout-khz061dw2'],
			},
			'layout-khynvdhh': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'percentage', value: 100 },
					hidden: false,
				},
				itemLayout: {
					type: 'StackItemLayout',
					margins: { left: { type: 'percentage', value: 0 }, top: { type: 'px', value: 0 } },
					alignSelf: 'center',
					order: 1,
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khynvdhh',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khynvtab': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'percentage', value: 100 },
					hidden: false,
				},
				itemLayout: {
					type: 'StackItemLayout',
					margins: {
						left: { type: 'percentage', value: 0 },
						right: { type: 'px', value: 0 },
						top: { type: 'px', value: 10 },
						bottom: { type: 'px', value: 0 },
					},
					alignSelf: 'start',
					order: 2,
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khynvtab',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khyp5z7d': {
				type: 'RefArray',
				id: 'layout-khyp5z7d',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#layout-khyp9qd6', '#layout-khyp9qd62', '#layout-khyp9qd72'],
			},
			'layout-khyp9qd6': {
				type: 'VariantRelation',
				id: 'layout-khyp9qd6',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#layout-khyp9qd61',
				from: '#comp-kirk42ax',
				variants: ['#breakpoints-kc1s7zda1'],
			},
			'layout-khyp9qd61': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'percentage', value: 100 },
					maxWidth: { type: 'px', value: 400 },
				},
				itemLayout: {
					type: 'StackItemLayout',
					margins: {
						left: { type: 'percentage', value: 0 },
						right: { type: 'px', value: 0 },
						top: { type: 'px', value: 20 },
						bottom: { type: 'px', value: 0 },
					},
					alignSelf: 'start',
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khyp9qd61',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khyp9qd62': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'percentage', value: 100 },
					maxWidth: { type: 'px', value: 500 },
					hidden: false,
				},
				itemLayout: {
					type: 'StackItemLayout',
					margins: {
						left: { type: 'percentage', value: 0 },
						right: { type: 'px', value: 0 },
						top: { type: 'px', value: 20 },
						bottom: { type: 'px', value: 0 },
					},
					alignSelf: 'start',
					order: 4,
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khyp9qd62',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khyp9qd72': {
				type: 'VariantRelation',
				id: 'layout-khyp9qd72',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#layout-khyp9qd73',
				from: '#comp-kirk42ax',
				variants: ['#breakpoints-kc1s7zda'],
			},
			'layout-khyp9qd73': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'auto' },
					width: { type: 'percentage', value: 100 },
					maxWidth: { type: 'px', value: 300 },
				},
				itemLayout: {},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khyp9qd73',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khz061dv': {
				type: 'VariantRelation',
				id: 'layout-khz061dv',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#layout-khz061dv1',
				from: '#comp-kirk42au',
				variants: ['#breakpoints-kc1s7zda'],
			},
			'layout-khz061dv1': {
				componentLayout: {},
				itemLayout: {
					type: 'GridItemLayout',
					margins: {
						left: { type: 'percentage', value: 9.333333 },
						right: { type: 'percentage', value: 9.333333 },
						top: { type: 'percentage', value: 26.666666 },
						bottom: { type: 'px', value: 0 },
					},
					gridArea: { rowStart: 1, columnStart: 1, rowEnd: 2, columnEnd: 2 },
					alignSelf: 'start',
					justifySelf: 'stretch',
				},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khz061dv1',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khz061dw': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'maxContent' },
					width: { type: 'auto' },
					maxWidth: { type: 'px', value: 750 },
					hidden: false,
				},
				itemLayout: {
					type: 'GridItemLayout',
					margins: {
						left: { type: 'percentage', value: 10.416667 },
						right: { type: 'percentage', value: 10.416667 },
						top: { type: 'percentage', value: 13.020833 },
						bottom: { type: 'px', value: 0 },
					},
					gridArea: { rowStart: 1, columnStart: 1, rowEnd: 2, columnEnd: 2 },
					alignSelf: 'start',
					justifySelf: 'stretch',
				},
				containerLayout: { type: 'StackContainerLayout', direction: 'column' },
				type: 'SingleLayoutData',
				id: 'layout-khz061dw',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
			'layout-khz061dw2': {
				type: 'VariantRelation',
				id: 'layout-khz061dw2',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				to: '#layout-khz061dw3',
				from: '#comp-kirk42au',
				variants: ['#breakpoints-kc1s7zda1'],
			},
			'layout-khz061dw3': {
				componentLayout: {
					type: 'ComponentLayout',
					height: { type: 'maxContent' },
					width: { type: 'auto' },
					maxWidth: { type: 'px', value: 99999 },
				},
				itemLayout: {},
				containerLayout: {},
				type: 'SingleLayoutData',
				id: 'layout-khz061dw3',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
			},
		},
		variants_data: {
			'breakpoints-k3sr3k4j': {
				type: 'BreakpointsData',
				id: 'breakpoints-k3sr3k4j',
				metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
				values: ['#breakpoints-kc1s7zda1', '#breakpoints-kc1s7zda'],
				componentId: '_500_dp',
			},
			'breakpoints-kc1s7zda': {
				type: 'BreakpointRange',
				id: 'breakpoints-kc1s7zda',
				metaData: { isPreset: false, schemaVersion: '2.0', isHidden: false },
				min: 320,
				max: 750,
			},
			'breakpoints-kc1s7zda1': {
				type: 'BreakpointRange',
				id: 'breakpoints-kc1s7zda1',
				metaData: { isPreset: false, schemaVersion: '2.0', isHidden: false },
				min: 320,
				max: 1000,
			},
		},
	},
	title: '500',
	pageUriSEO: '500',
	metaData: {},
})

export default _500_dp
